(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/get-engine.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/get-engine.js');

'use strict';

const {
  pixModes
} = svs.racing.common.constants;
const topp5 = svs.racing.gameEngine.engines.topp5;
const topp5System = svs.racing.gameEngine.engines.topp5System;
const topp5PixCustom = svs.racing.gameEngine.engines.topp5PixCustom;
const rx4io = svs.racing.gameEngine.engines.rx4io;
const rx4ioSystem = svs.racing.gameEngine.engines.rx4ioSystem;
const rx3ioao = svs.racing.gameEngine.engines.rx3ioao;
const rx3ioaoSystem = svs.racing.gameEngine.engines.rx3ioaoSystem;
const topp2 = svs.racing.gameEngine.engines.topp2;
const topp2System = svs.racing.gameEngine.engines.topp2System;
const rx2io = svs.racing.gameEngine.engines.rx2io;
const rx2ioSystem = svs.racing.gameEngine.engines.rx2ioSystem;
const rx2p = svs.racing.gameEngine.engines.rx2p;
const rx2pSystem = svs.racing.gameEngine.engines.rx2pSystem;
const rx2p4 = svs.racing.gameEngine.engines.rx2p4;
const rx2p4System = svs.racing.gameEngine.engines.rx2p4System;
const rx3io = svs.racing.gameEngine.engines.rx3io;
const rx3ioSystem = svs.racing.gameEngine.engines.rx3ioSystem;
const vinnare = svs.racing.gameEngine.engines.vinnare;
const plats = svs.racing.gameEngine.engines.plats;
const rx3ao = svs.racing.gameEngine.engines.rx3ao;
const rx3aoSystem = svs.racing.gameEngine.engines.rx3aoSystem;
const gameTypes = svs.racing.common.constants.gameTypes;
const getEngine = function (gameType) {
  let isSystem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let pixMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  switch (gameType) {
    case gameTypes.TOPP5:
      if (isSystem) {
        return topp5System;
      }
      return pixMode === pixModes.CUSTOM ? topp5PixCustom : topp5;
    case gameTypes.RX4IO:
      return isSystem ? rx4ioSystem : rx4io;
    case gameTypes.RX3IOAO:
      return isSystem ? rx3ioaoSystem : rx3ioao;
    case gameTypes.TOPP2:
      return isSystem ? topp2System : topp2;
    case gameTypes.RX2IO:
      return isSystem ? rx2ioSystem : rx2io;
    case gameTypes.RX2P:
      return isSystem ? rx2pSystem : rx2p;
    case gameTypes.RX2P4:
      return isSystem ? rx2p4System : rx2p4;
    case gameTypes.RX3AO:
      return isSystem ? rx3aoSystem : rx3ao;
    case gameTypes.RX3IO:
      return isSystem ? rx3ioSystem : rx3io;
    case gameTypes.VINNARE:
      return vinnare;
    case gameTypes.PLATS:
      return plats;
    default:
      throw new Error("Unknown game type: ".concat(gameType));
  }
};
svs.racing.gameEngine.getEngine = getEngine;

 })(window);